export default "__VITE_ASSET__CBSG8WIe__"